import { configure } from "mobx";
import { createRoot } from "react-dom/client";
import { clearStoredReferrer } from "@/hooks/useReferrer";
import App from "@/App";
import "@/index.css";

configure({ enforceActions: "observed", useProxies: "ifavailable" });

window.addEventListener("beforeunload", async (event) => {
	event.stopImmediatePropagation();
	console.log("on beforeunload event fired!");

	// Clear the stored referrer when the user leaves the app
	clearStoredReferrer();
});

async function renderApp(): Promise<void> {
	const rootElement = document.getElementById("app-container");

	if (rootElement == null) {
		throw new Error("root element not found");
	}

	const root = createRoot(rootElement);

	console.log("rendering app");

	root.render(<App />);
}

renderApp();
